/* eslint-disable react/jsx-pascal-case */
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'store'
import T_Main from 'components/4_Templates/T_Main'
import C1_Juryo from 'components/5_Pages/Contents/C1_Juryo'
import { labels } from 'types/ReferTypes'
import { getMenuLabel } from 'utils/stringUtil'
import * as PageAction from 'slicers/PageSlice'
import * as LoginAction from 'slicers/LoginSlice'
import * as SearchJuryoAction from 'slicers/SearchSlicers/SearchJuryoSlice'
import { useExpand, useExpandDetail } from 'hooks/useJuryo'

const P_Juryo = ({ labels }: { labels: labels }) => {
  const dispatch = useDispatch()
  const loginKbn = useSelector((state) => state.LoginReducer.loginKbn)
  const isJapell = useSelector((state) => state.LoginReducer.isJapell)
  const isSuper = useSelector((state) => state.LoginReducer.isSuper)
  const keyInfo = useSelector((state) => state.LoginReducer.keyInfo)
  const history = useHistory()
  const [expand, changeExpand] = useExpand()
  const [expandDetail, changeExpandDetail] = useExpandDetail()
  const detailView = useSelector((state) => state.SearchJuryoReducer.detailView)

  useEffect(() => {
    dispatch(PageAction.deleteMessage())
    dispatch(SearchJuryoAction.initialize({ isJapell: isJapell, isSuper: isSuper, JIGYO_CD: keyInfo[0].JIGYO_CD })) // 初期状態に設定
  }, [])

  if (loginKbn !== 2) {
    dispatch(LoginAction.format())
    history.push('/') // ログイン画面に遷移
    return <></>
  }

  return (
    <T_Main labels={labels} pageTitle={getMenuLabel(labels.sideMenus[0])} expandMode={true} open={detailView ? expandDetail : expand} changeOpen={detailView ? changeExpandDetail : changeExpand}>
      <C1_Juryo />
    </T_Main>
  )
}

export default P_Juryo
